export const LC_AUTH_TOKEN = "token";

export const READING_REQUEST_CACHED_MESSAGE = "cachedMessage";

export const AppTheme = "appTheme";

export const CREATE_READING_CACHED_FORM = "cachedNewReadingForm";

export const CHUNK_AUTO_REFRESH = "chunkAutoRefresh";

export const PERSONALITY_CHANGE_TOKEN = "personalityChangeToken";

export const UTM_FIELDS = "utmFields";

export const POST_SUBSCRIPTION_RETURN_PATH = "postSubscriptionReturnPath";
